import { Link } from "react-router-dom/cjs/react-router-dom.min"
import TapIcon from "../../../services/TapIcon"
import { useEffect, useRef, useState } from "react"
import HttpAPICall from "../../../services/HttpAPICall";
import { useSelector } from "react-redux";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import Loader from "../../../components/ui/Loader/Loader";
import { DisplayListPagination } from "../../../components/TapUi";
import InitializedModel from "./InitializedModel";
import Status from "../../../components/ui/Status";

function AssetMatrixSCSListing({detailData}) {

    const amScsUrl              =   BACKOFFICE_BASE_URL + '/asset_matrix_scs/';
    const access_token          =   useSelector(state => state.auth.access_token);
    const assetMatrixId         =   detailData.asset_matrix_unique_id;
    const initializedRef        =   useRef(null);

    const [amScsData, setAmScsData] =   useState({
        loading     :   false,
        data        :   [],
        meta        :   null
    });
    const [allMeters, setAllMeters]         =   useState([]);
    const [isInitialized, setIsInitialized] =   useState(true);
    const [modalData, setModalData]         =   useState({
        asset_matrix_id     :   detailData.id,
        scs_ids             :   [],
    });
    const [currentPage, setCurrentPage]     =   useState(1);

    useEffect(() => {
        linkingData();
    }, [detailData]);

    const linkingData =   (page = 1)  => {
        setAmScsData(pre => ({...pre, loading: true}));
        setCurrentPage(page);
        HttpAPICall.withAthorization('GET', amScsUrl + assetMatrixId, access_token, {page, assetMatrixId}, {}, (resp) => {
            const respData = resp.data.scsList;
            setAllMeters(resp.data.allMeters)    
            setAmScsData(pre => ({
                ...pre, 
                data:   respData.data.map(d => ({...d, checked : false})),
                meta:   {
                'from'          :   respData.from, 
                'to'            :   respData.to, 
                'total'         :   respData.total, 
                'last_page'     :   respData.last_page, 
                'per_page'      :   respData.per_page, 
                'current_page'  :   respData.current_page
                }
            }));
            
        }).then(() => setAmScsData(pre => ({...pre, loading: false})));
    }

    const initializeModalHandle =   (data = null)  => {      
        let modalData               =   null;
        if(data) {
            modalData               =   {
                scs_ids                 :   [data.id],
                asset_matrix_id         :   detailData.id,
            }   
            allMeters.forEach(meter => {
                const mData         =   data.linking_data;
                const intervalKey   =   "interval_" + meter.key;
                modalData           =   {
                    ...modalData,
                    [intervalKey]       :   mData[intervalKey],
                    [meter.key]         :   mData[meter.key],
                    'days_check'        :   mData.days_check,
                    'days_interval'     :   mData.days_interval,
                    'status'            :   mData.status
                }
            })
        }
        initializedRef.current.initModalHandler(modalData);
    }

    const handleCheckboxChange  =   (id) => {
        const data  =    amScsData.data.map(d => d.id == id ? {...d, checked : !d.checked} : d);
        setAmScsData(pre => ({
            ...pre,
            data
        }));
        const checkedData =   data.filter(d => d.checked);
        setIsInitialized(!checkedData.length > 0);
        setModalData(pre => ({
            ...pre,
            scs_ids : checkedData.map(d => d.id).length > 0 ? checkedData.map(d => d.id) : []
        }))

    }

    const reloadList    =   () => {
        linkingData(currentPage);
    }


  return (
    <>
    <div className="tab_content_header">
        <div className="tab_content_wrapper mt-4"><span className="content_heading">CheckSheets List</span>
                <div className="text-end">
                    <button type="button" disabled={amScsData.loading || isInitialized} className="btn btn-secondary" onClick={() => initializeModalHandle()}>
                        Initialized
                    </button>
                </div>
        </div>
        <table className="table table-hover table-sm table-bordered  table-responsive bg-white my-2 mb-5">
            <thead className="table-secondary">
                <tr className='text-center'>
                    <th style={{ width: "5%" }}>#</th>
                    <th style={{ width: "15%" }}>Name</th>
                    <th style={{ width: "15%" }}>Section</th>
                    <th style={{ width: "15%" }}>Sub-Section</th>
                    <th style={{ width: "15%" }}>Initialized</th>
                    <th style={{ width: "25%" }}>Interval</th>
                    <th style={{ width: "10%" }}>Actions</th>
                </tr>
            </thead>
            <tbody>
                { amScsData.loading 
                    ? <tr className='text-center'><td colSpan={6}><Loader /></td></tr>
                    : amScsData.data.length > 0 ?
                        <>
                        {
                            amScsData.data.map(data => (
                                <tr key={data.id}>
                                    <td className='text-center'>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={data.checked}
                                            onChange={() => handleCheckboxChange(data.id)}
                                        />
                                    </td>
                                    <td className='text-center'>{data.name}</td>
                                    <td>{data.section ? data.section.component : '-'}</td>
                                    <td className='text-center'>{data.sub_section ? data.sub_section.subcomponent : '-'}</td>
                                    <td className='text-center'>{data.linking_data && data.linking_data.status_data && <Status color={data.linking_data.status_data.status_color_code}>{data.linking_data.status_data.status_text}</Status>}</td>
                                    <td>
                                        {
                                        allMeters.map(meter => {
                                            const mData = data.linking_data;
                                            const labelKey  =   meter.key + "_label";
                                            const intervalKey=  "interval_" + meter.key;
                                            
                                            return <><span>{mData[labelKey] || meter.name} : <b>{mData[intervalKey]}</b></span><br/></>
                                        })
                                        }
                                        <span>Days Interval : <b>{data.linking_data.days_interval}</b></span>
                                    </td>
                                    <td className='text-center'>
                                        <TapIcon.imageIcon icon={TapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li><button className="dropdown-item" role="button" onClick={() => initializeModalHandle(data)}>Initialized</button></li>
                                            {/* <li><a className="dropdown-item" role="button">Uninitialized</a></li> */}
                                        </ul>
                                    </td>
                                </tr>
                            ))
                        }
                        </>
                        :
                        <tr className='text-center'>
                            <td colSpan={6}>No Record</td>
                        </tr>
                }

            </tbody>
        </table>
        <DisplayListPagination
            meta={amScsData.meta}
            onPageChange={(e) => linkingData(e.selected + 1)}
        />
    </div>
    <InitializedModel ref={initializedRef} allMeters={allMeters} data={modalData} reloadList={reloadList}/>
    </>
  )
}

export default AssetMatrixSCSListing